// extracted by mini-css-extract-plugin
module.exports = {"container":"GCm0SsBS","containerActive":"QP2XXz3C GCm0SsBS","markdownWrapper":"_CSEtPzQ","styledLabel":"o_2B_tLO","quoteContext":"rHTdIPh1"};